require("utility/error_boundary.scss")

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false, lastErrorKey: null };
	}

	componentDidCatch(error, info) {
		this.setState({ hasError: true, lastErrorKey: this.props.errorKey });
	}

	showError() {
		return this.state.hasError && (this.props.errorKey == this.state.lastErrorKey);
	}

	render() {
		if (this.showError()) {
			if (this.props.type == "big") {
				var content = (
					<p className="bigError">
						Whooo's Reading is temporarily having an unknown error for your account. 
						Please try refreshing the page in a few minutes. If you still experience this error after that, 
						please <a href="https://www.whooosreading.org/contact">contact us</a>.
					</p>
				);
			} else if (this.props.errorMessage) {
				var content = (
					<p>
						{ this.props.errorMessage }
					</p>
				);

			} else {
				var content = (
					<p>
						Something went wrong. Please try again.
					</p>
				);
			}
			return (
				<div className="errorBoundary">
					{ content }
				</div>
			)
		} else {
			return this.props.children;			
		}
	}
}

ErrorBoundary.propTypes = StrictPropTypes({
	children: PropTypes.PropTypes.oneOfType([
		PropTypes.object,
		PropTypes.array
	]),

	type: PropTypes.string,
	errorMessage: PropTypes.string,
	errorKey: PropTypes.string
});


module.exports = ErrorBoundary;


// WEBPACK FOOTER //
// ./modules/components/utility/ErrorBoundary.js